import { csrfFetch } from '../utils/csrfFetch';

// Constants
const CREATE_BUILDING = 'buildings/CREATE_BUILDING'
const LOAD_BUILDINGS = 'buildings/LOAD_BUILDINGS';
const UPDATE_BUILDING = 'buildings/UPDATE_BUILDING';
const DELETE_BUILDING = "buildings/DELETE_BUILDING";

// Action Creators
const createBuilding = (building) => ({
  type: CREATE_BUILDING,
  payload: building,
});

export const loadBuildings = (buildings) => ({
  type: LOAD_BUILDINGS,
  payload: buildings
});


export const editBuilding = (building) => ({
  type: UPDATE_BUILDING,
  payload: building,
});

const deleteBuilding = (id) => ({
  type: DELETE_BUILDING,
  payload: id
});

// Thunks
export const createBuildingAdmin = (buildingData) => async (dispatch) => {
  try {
    const response = await csrfFetch('/api/buildings/new', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...buildingData,
        account_id: parseInt(buildingData.account_id),
        building_door_number: parseInt(buildingData.building_door_number)
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw error;
    }

    const newBuilding = await response.json();
    dispatch(createBuilding(newBuilding));
    return newBuilding;
  } catch (error) {
    console.error('Error in createBuildingAdmin:', error);
    throw error;
  }
};

export const fetchBuildingsAdmin = () => async (dispatch) => {
  const response = await csrfFetch('/api/buildings/');
  if (response.ok) {
    const buildings = await response.json();
    dispatch(loadBuildings(buildings));
    return buildings;
  }
};

export const fetchBuildingsUser = (accountId) => async (dispatch) => {
  try {
    let url = '/api/buildings/';
    if (accountId) {
      url += `?account_id=${accountId}`;
    }

    const response = await csrfFetch(url);

    if (response.ok) {
      const buildings = await response.json();
      dispatch(loadBuildings(buildings));
      return buildings;
    } else {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch buildings');
    }
  } catch (error) {
    console.error('Error fetching buildings:', error);
    throw error;
  }
};

export const updateBuilding = (buildingData) => async (dispatch) => {
    console.log('**********UPDATE BUILDING STORE **********', buildingData.id)
  try {
    const response = await csrfFetch(`/api/buildings/${buildingData.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(buildingData)
    });

    if (!response.ok) {
      const errors = await response.json();
      throw new Error(JSON.stringify(errors));
    }

    const building = await response.json();
    dispatch(editBuilding(building));
    return building;
  } catch (error) {
    console.error('Error updating building:', error);
    throw error;
  }
};

export const getBuildingById = (id) => async (dispatch) => {
  try {
    const response = await csrfFetch(`/api/buildings/${id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch building');
    }
    const building = await response.json();
    dispatch(editBuilding(building));
    return building;
  } catch (error) {
    console.error('Error fetching building:', error);
    throw error;
  }
};

export const deleteBuildingAdmin = (id) => async (dispatch) => {
  try {
    const response = await csrfFetch(`/api/buildings/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(JSON.stringify(errorData));
    }
    dispatch(deleteBuilding(id));
    return response;
  } catch (error) {
    console.error('Error deleting building:', error);
    throw error;
  }
};

// Reducer
const initialState = [];

const buildingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_BUILDINGS:
      return action.payload;
    case UPDATE_BUILDING:
      return state.map(building =>
        building.id === action.payload.id ? action.payload : building
      );
    case DELETE_BUILDING:
      return state.filter(building => building.id !== action.payload);
    case CREATE_BUILDING:
      return [...state, action.payload];
    default:
      return state;
  }
};

export default buildingsReducer;
